























































































import Vue from "vue";
import AppBar from "@/components/modules/skills/AppBar.vue";
import { mapActions, mapGetters } from "vuex";
import {
  DEMAND_SKILL_DATA,
  SUPPLY_SKILL_DATA
} from "@/store/modules/institute/constants";
import { LOGOUT_USER } from "@/store/modules/auth/constants";
import { get_skill_related_data } from "@/utils/skills_data";
import CustomSelect from "@/components/shared/CustomSelect.vue";

export default Vue.extend({
  name: "RecruiterWrapper",
  components: { AppBar, CustomSelect },
  data() {
    return {
      select_category_filter: "",
      select_industry_filter: "",
      select_job_filter: "",
      select_institute_filter: "",
      select_course_filter: ""
    };
  },
  mounted() {
    this.set_filters();
  },
  watch: {
    $route() {
      this.set_filters();
    }
  },
  computed: {
    ...mapGetters("institute", {
      get_demand_data: DEMAND_SKILL_DATA,
      get_supply_data: SUPPLY_SKILL_DATA
    })
  },
  methods: {
    get_skill_related_data,
    ...mapActions("auth", {
      logout_user: LOGOUT_USER
    }),
    change_job_title(item: string) {
      if (["/skills/demand", "/skills/new-demand"].includes(this.$route.path))
        this.get_demand_data.job_title = item;
      this.$emit("change_filter");
    },
    change_industry(item: string) {
      if (["/skills/demand", "/skills/new-demand"].includes(this.$route.path))
        this.get_demand_data.industry = item;
      this.$emit("change_filter");
    },
    change_category(item: string) {
      if (["/skills/demand", "/skills/new-demand"].includes(this.$route.path))
        this.get_demand_data.category = item;
      else this.get_supply_data.category = item;
      this.$emit("change_filter");
    },
    change_institute(item: string) {
      if (this.$route.path === "/skills/supply")
        this.get_supply_data.institute = item;
      this.$emit("change_filter");
    },
    change_course(item: string) {
      if (this.$route.path === "/skills/supply")
        this.get_supply_data.course_title = item;
      this.$emit("change_filter");
    },
    set_filters() {
      if (["/skills/demand", "/skills/new-demand"].includes(this.$route.path)) {
        this.select_category_filter = this.get_demand_data.category;
        this.select_industry_filter = this.get_demand_data.industry;
        this.select_job_filter = this.get_demand_data.job_title;
      } else {
        this.select_category_filter = this.get_supply_data.category;
        this.select_institute_filter = this.get_supply_data.institute;
        this.select_course_filter = this.get_supply_data.course_title;
      }
      this.$emit("change_filter");
    }
  }
});
